import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "radioFilter",
})
export class RadioFilterPipe implements PipeTransform {
  transform(items: any[], searchText: string): any[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLowerCase();
    
    return items?.filter((item) => {
      return item?.nom_Radio?.toLowerCase().includes(searchText);
    });
  }
}
